import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Quote } from "lucide-react";

export default function Testimonials() {
  const [items, setItems] = useState([]);
  const [i, setI] = useState(0);
  useEffect(() => { api.get("/testimonials").then((r) => setItems(r.data.items || [])).catch(() => {}); }, []);
  useEffect(() => { if (items.length < 2) return; const t = setInterval(() => setI((x) => (x + 1) % items.length), 5000); return () => clearInterval(t); }, [items.length]);
  if (!items.length) return null;
  const t = items[i];
  return (
    <section className="border-t border-slate-800/80 bg-[#070b14]" data-testid="gate-testimonials">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-8">
        <Quote className="w-8 h-8 text-blue-500/70 shrink-0" />
        <div key={t.testimonial_id} className="flex-1 min-w-0 rise">
          <p className="text-base sm:text-lg text-slate-100 leading-snug" data-testid="testimonial-quote">“{t.quote}”</p>
          <p className="text-xs text-slate-400 mt-1.5" data-testid="testimonial-name">{t.name} · {t.role}</p>
        </div>
        {t.earnings && <div className="shrink-0 rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-2 text-center"><p className="font-mono text-xl text-emerald-300" data-testid="testimonial-earnings">{t.earnings}</p><p className="text-[10px] uppercase tracking-widest text-emerald-400/70">on Velocity</p></div>}
        <div className="flex gap-1.5 sm:flex-col">{items.slice(0, 8).map((_, k) => <button key={k} onClick={() => setI(k)} aria-label={`Quote ${k + 1}`} className={`w-1.5 h-1.5 rounded-full ${k === i % 8 ? "bg-blue-400" : "bg-slate-700"}`} />)}</div>
      </div>
    </section>
  );
}
